// extracted by mini-css-extract-plugin
module.exports = {"root":"options_root__3v3D-","sub-content":"options_sub-content__2J84q"};